<div class="login-background" [class]="settings.login.form.position === 'right' ? 'flex-row' : 'flex-row-reverse'">
  <div class="prevent-click"></div>
  <div class="login-header px-5 py-2">
    <div class="brand-image logo1"></div>
    <div class="brand-image logo2"></div>
  </div>
  <div [class]="settings.login.form.position === 'center' ? 'login-center card': 'login-side'">
    <div class="form-container py-4 px-5" [class]="settings.login.form.backgroundColor === 'black' ? 'invert': ''">
      <div class="logo-section" *ngIf="settings.logo[3]?.image">
        <div class="brand-image logo3"></div>
      </div>
      <ng-container *ngIf="step === 'login'">
        <div class="my-4">
          <h5 class="fw-bold mb-4">{{ 'LOGIN.LOGIN' | translate }}</h5>
          <form [formGroup]="loginForm" (ngSubmit)="login()">
            <div class="form-floating mb-3">
              <input id="floatingUser" formControlName="user" type="user" class="form-control" placeholder="User">
              <label for="floatingUser">{{ 'LOGIN.USER' | translate }}</label>
              <small class="mt-3">{{ 'LOGIN.TIP' | translate }}</small>
              <hbo-control-messages [control]="loginForm.get('user')!"></hbo-control-messages>
            </div>
            <div class="form-floating mb-2">
              <input id="floatingPassword" formControlName="password" type="password" class="form-control"
                placeholder="Password">
              <i class="bi bi-eye" (click)="togglePassword('floatingPassword')"></i>
              <label for="floatingPassword">{{ 'LOGIN.PASSWORD' | translate }}</label>
              <hbo-control-messages [control]="loginForm.get('password')!"></hbo-control-messages>
            </div>
            <div role="button" aria-hidden="true" class="mb-4 forgot-buttom" (click)="step = 'password-forgotten'">{{
              'LOGIN.FORGOT_PASSWORD' | translate }}</div>
            <button type="" class="btn w-100 py-3"
              [class]="settings.login.form.backgroundColor === 'black' ? 'btn-light': 'btn-dark'"
              [disabled]="loginForm.invalid">{{ 'LOGIN.LOGIN' | translate }}</button>
          </form>
          <div class="mt-3 text-center" *ngIf="settings.sendPasswordEmail === false">
            <p class="mb-1">{{ 'LOGIN.PRE_ACTIVATED_ACCOUNT' | translate }}</p>
            <span role="button" aria-hidden="true" class="fw-bold text-dark" (click)="step = 'first-registration'">{{ 'LOGIN.CLICK_FIRST_REGISTRATION' | translate }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'password-forgotten'">
        <div class="my-2">
          <h5 class="fw-bold mb-4">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</h5>
          <p>{{ 'LOGIN.DONT_WORRY' | translate }}</p>
          <form [formGroup]="passwordForgottenForm">
            <div class="form-floating mb-5">
              <input id="floatingEmail" formControlName="email" type="email" class="form-control" placeholder="Email">
              <label for="floatingEmail">{{ 'LOGIN.EMAIL' | translate }}</label>
              <hbo-control-messages [control]="passwordForgottenForm.get('email')!"></hbo-control-messages>
            </div>
            <div class="row">
              <div class="col-6">
                <button class="btn w-100 py-3 btn btn-dark" [disabled]="passwordForgottenForm.invalid"
                  (click)="passwordForgotten()">{{ 'LOGIN.SEND' | translate }}</button>
              </div>
              <div class="col-6">
                <button class="w-100 py-3 btn btn-light border-black" (click)="step = 'login'">{{ 'LOGIN.CANCEL' |
                  translate }}</button>
              </div>
            </div>
          </form>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'forgot-sended'">
        <div class="my-2 text-center">
          <img src="assets/images/email.svg" alt=""
            [class]="settings.login.form.backgroundColor === 'black' ? 'invert-color': ''">
          <h5 class="fw-bold">{{ 'LOGIN.CHECK_EMAIL' | translate }}</h5>
          <p class="mb-3">{{ 'LOGIN.EMAIL_SENT' | translate }}</p>
          <p>{{ 'LOGIN.RESET_PASSWORD' | translate }}</p>
          <button class="w-100 py-3 btn"
            [class]="settings.login.form.backgroundColor === 'black' ? 'btn-light': 'btn-dark'"
            (click)="step = 'login'">{{ 'LOGIN.GOTO_LOGIN' | translate }}</button>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'set-password'">
        <form [formGroup]="setPasswordForm">
          <div class="form-floating mb-2">
            <input id="floatingPassword" formControlName="newPassword" type="password" class="form-control"
              placeholder="Password">
            <i class="bi bi-eye" (click)="togglePassword('floatingPassword')"></i>
            <label for="floatingPassword">{{ 'LOGIN.PASSWORD' | translate }}</label>
            <hbo-control-messages [control]="setPasswordForm.get('newPassword')!"></hbo-control-messages>
          </div>
          <div class="form-floating mb-4">
            <input id="floatingRepeatPassword" formControlName="repeatPassword" type="password" class="form-control"
              placeholder="Password">
            <i class="bi bi-eye" (click)="togglePassword('floatingRepeatPassword')"></i>
            <label for="floatingRepeatPassword">{{ 'LOGIN.REPEAT_PASSWORD' | translate }}</label>
            <hbo-control-messages [control]="setPasswordForm.get('repeatPassword')!"></hbo-control-messages>
          </div>
          <div class="row">
            <div class="col-12">
              <button class="btn w-100 py-3 btn btn-dark" [disabled]="setPasswordForm.invalid"
                (click)="changePassword()">{{ 'COMMON.SAVE' | translate }}</button>
            </div>
          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="step === 'password-set'">
        <p>{{ 'LOGIN.PASSWORD_SET' | translate }}</p>
        <div class="my-2 text-center">
          <button class="w-100 py-3 btn"
            [class]="settings.login.form.backgroundColor === 'black' ? 'btn-light': 'btn-dark'"
            (click)="step = 'login'">{{ 'LOGIN.GOTO_LOGIN' | translate }}</button>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'link-expired'">
        <div class="my-2 text-center">
          <i class="bi bi-exclamation-triangle" style="font-size: 4rem; color: #ffc107;"></i>
          <h5 class="fw-bold mt-3">{{ 'LOGIN.LINK_EXPIRED_TITLE' | translate }}</h5>
          <p class="mb-3">{{ 'LOGIN.LINK_EXPIRED_MESSAGE' | translate }}</p>
          <button class="w-100 py-3 btn"
            [class]="settings.login.form.backgroundColor === 'black' ? 'btn-light': 'btn-dark'"
            (click)="step = 'password-forgotten'">{{ 'LOGIN.REQUEST_NEW_LINK' | translate }}</button>
        </div>
      </ng-container>
      <ng-container *ngIf="step  === 'password-already-set'">
        <div class="my-2 text-center">
          <i class="bi bi-exclamation-triangle" style="font-size: 4rem; color: #ffc107;"></i>
          <h5 class="fw-bold mt-3">{{ 'LOGIN.LINK_USED_TITLE' | translate }}</h5>
          <p class="mb-3">{{ 'LOGIN.LINK_USED_MESSAGE' | translate }}</p>
          <button class="w-100 py-3 btn"
            [class]="settings.login.form.backgroundColor === 'black' ? 'btn-light': 'btn-dark'"
            (click)="step = 'login'">{{ 'LOGIN.GOTO_LOGIN' | translate }}</button>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'first-registration'">
        <div class="my-2">
          <h5 class="fw-bold mb-4">{{ 'LOGIN.FIRST_REGISTRATION_TITLE' | translate }}</h5>
          <p>{{ 'LOGIN.FIRST_REGISTRATION_BODY' | translate }}</p>
          <form [formGroup]="firstRegistrationForm">
            <div class="form-floating mb-5">
              <input id="floatingEmailFirstReg" formControlName="email" type="email" class="form-control" placeholder="Email">
              <label for="floatingEmailFirstReg">{{ 'LOGIN.EMAIL' | translate }}</label>
              <hbo-control-messages [control]="firstRegistrationForm.get('email')!"></hbo-control-messages>
            </div>
            <div class="row">
              <div class="col-6">
                <button class="btn w-100 py-3 btn btn-dark" [disabled]="firstRegistrationForm.invalid"
                  (click)="firstRegistration()">{{ 'LOGIN.SEND' | translate }}</button>
              </div>
              <div class="col-6">
                <button class="w-100 py-3 btn btn-light border-black" (click)="step = 'login'">{{ 'LOGIN.CANCEL' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'first-registration-sent'">
        <div class="my-2 text-center">
          <img src="assets/images/email.svg" alt=""
            [class]="settings.login.form.backgroundColor === 'black' ? 'invert-color': ''">
          <h5 class="fw-bold">{{ 'LOGIN.CHECK_EMAIL' | translate }}</h5>
          <p class="mb-3">{{ 'LOGIN.EMAIL_SENT' | translate }}</p>
          <p>{{ 'LOGIN.FIRST_REGISTRATION_SENT' | translate }}</p>
          <button class="w-100 py-3 btn"
            [class]="settings.login.form.backgroundColor === 'black' ? 'btn-light': 'btn-dark'"
            (click)="step = 'login'">{{ 'LOGIN.GOTO_LOGIN' | translate }}</button>
        </div>
      </ng-container>
      <!--<div class="form-footer">Powered by <img src="assets/images/logo-invision.svg" alt=""></div>-->
    </div>
  </div>
</div>